import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 20px;
	user-select: none;
`;

export { StyledContainer };
